import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61657cc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 1,
  class: "flex align-items-center p-2"
}
const _hoisted_3 = {
  key: 2,
  class: "Dropdown__Option"
}

import Skeleton from "primevue/skeleton"
import Dropdown, { DropdownFilterEvent } from "primevue/dropdown"
import { Select } from "./MDropdown.interface"

import { computed, WritableComputedRef, Ref } from "vue"

import { usarRolagemInfinita } from "@/composable/UsarRolagemInfinita/usarRolagemInfinita"
import { usarDebounces } from "@/composable/UsarDebounces/usarDebounces"
import { useI18n } from "vue-i18n"

interface Props {
  id?: string
  placeholder?: string
  mensagemDeErro?: string | Ref<string>
  modelValue?: any
  optionLabel?: string
  optionValue?: string
  options: Select[] | string[] | Date[]
  desativado?: boolean
  carregando?: boolean
  destino?: string
  filtro?: boolean
  filtroPlaceholder?: string
  dataTestid?: string
  width?: string
  buscarMaisItens?: () => void
  atrasoRolagemInfinita?: number
  usarCarregamentoSobDemanda?: boolean
  tamanhoDoItem?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MDropdown',
  props: {
    id: null,
    placeholder: null,
    mensagemDeErro: null,
    modelValue: null,
    optionLabel: null,
    optionValue: null,
    options: null,
    desativado: { type: Boolean },
    carregando: { type: Boolean },
    destino: null,
    filtro: { type: Boolean, default: true },
    filtroPlaceholder: { default: "" },
    dataTestid: { default: "Dropdown__Componente" },
    width: null,
    buscarMaisItens: null,
    atrasoRolagemInfinita: { default: 400 },
    usarCarregamentoSobDemanda: { type: Boolean, default: false },
    tamanhoDoItem: { default: 45 }
  },
  emits: ["update:modelValue", "onFiltrandoBusca"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: "update:modelValue", modelValue: Select): void
  (event: "onFiltrandoBusca", valorFiltrado: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id?: string, placeholder?: string, mensagemDeErro?: string | Ref<string>, modelValue?: any, optionLabel?: string, optionValue?: string, options: Select[] | string[] | Date[], desativado?: boolean, carregando?: boolean, destino?: string, filtro: boolean, filtroPlaceholder: string, dataTestid: string, width?: string, buscarMaisItens?: () => void, atrasoRolagemInfinita: number, usarCarregamentoSobDemanda: boolean, tamanhoDoItem: number }

const { t } = useI18n()



const filtroPlaceholder = props.filtroPlaceholder || t("buscarPorNome")

const configuracoesVirtualScroller = props.usarCarregamentoSobDemanda
  ? {
      itemSize: props.tamanhoDoItem,
      lazy: true,
      delay: 0,
      showLoader: true,
    }
  : undefined



const emitirModel: WritableComputedRef<Select> = computed({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(): any {
    return props.modelValue
  },
  set(value: Select) {
    emits("update:modelValue", value)
  },
})

const { debounce } = usarDebounces()

const estaUsandoCarregamentoSobDemanda = computed(
  () => props.usarCarregamentoSobDemanda
)

const filtrandoBusca = debounce<DropdownFilterEvent>(
  (evento: DropdownFilterEvent) => {
    emits("onFiltrandoBusca", evento.value)
  },
  400
)

const { adicionarEventoDeRolagem, removerEventoDeRolagem } =
  usarRolagemInfinita({
    buscarMaisItens: props.buscarMaisItens,
    atrasoRolagemInfinita: props.atrasoRolagemInfinita,
    querySelecaoListaDeItens: ".p-virtualscroller",
  })

const abriuAGaveta = (): void => {
  if (!estaUsandoCarregamentoSobDemanda.value) {
    return
  }
  adicionarEventoDeRolagem()
}

const fechouAGaveta = (): void => {
  if (!estaUsandoCarregamentoSobDemanda.value) {
    return
  }
  removerEventoDeRolagem()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "Dropdown p-input-filled field",
    "data-testid": "dropdown"
  }, [
    _createVNode(_unref(Dropdown), {
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
      onFilter: _unref(filtrandoBusca),
      onHide: fechouAGaveta,
      onShow: abriuAGaveta,
      "append-to": __props.destino,
      class: _normalizeClass({ 'p-invalid': __props.mensagemDeErro }),
      "data-testid": __props.dataTestid,
      disabled: __props.desativado || __props.carregando,
      filter: __props.filtro,
      "filter-placeholder": _unref(filtroPlaceholder),
      loading: __props.carregando,
      "option-label": __props.optionLabel,
      "option-value": __props.optionValue,
      options: __props.options,
      "panel-style": { width: __props.width },
      placeholder: __props.placeholder,
      "virtual-scroller-options": _unref(configuracoesVirtualScroller)
    }, {
      option: _withCtx(({ option: opcao }) => [
        (__props.carregando)
          ? (_openBlock(), _createBlock(_unref(Skeleton), {
              key: 0,
              height: "1rem",
              width: "50%"
            }))
          : (typeof opcao === 'string')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(opcao), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(opcao.nome), 1),
                _createElementVNode("span", null, _toDisplayString(opcao.descricao), 1)
              ]))
      ]),
      _: 1
    }, 8, ["modelValue", "onFilter", "append-to", "class", "data-testid", "disabled", "filter", "filter-placeholder", "loading", "option-label", "option-value", "options", "panel-style", "placeholder", "virtual-scroller-options"]),
    _withDirectives(_createElementVNode("small", {
      id: "dropdown-help",
      class: "p-error",
      "data-testid": "dropdown-error"
    }, _toDisplayString(__props.mensagemDeErro), 513), [
      [_vShow, __props.mensagemDeErro]
    ])
  ], 8, _hoisted_1))
}
}

})